(function(){
  function ready(fn){if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}}
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(scope){
    if(reduce||!('IntersectionObserver' in window))return;
    var els=[].slice.call(scope.querySelectorAll('.mgm[data-animate] .mgm-r'));
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mgm-in');io.unobserve(e.target)}});
    },{rootMargin:'0px 0px -8% 0px',threshold:.06});
    els.forEach(function(el){io.observe(el)});
    function fallback(){var vh=window.innerHeight;els.forEach(function(el){if(el.classList.contains('mgm-in'))return;var r=el.getBoundingClientRect();if(r.top<vh&&r.bottom>0){el.classList.add('mgm-in');io.unobserve(el)}})}
    fallback();setTimeout(fallback,400);setTimeout(fallback,1400);window.addEventListener('load',fallback);
  }

  function initCues(scope){
    [].slice.call(scope.querySelectorAll('[data-mgm-cues]')).forEach(function(root){
      if(root.__mgmInit)return;root.__mgmInit=true;
      var steps=[].slice.call(root.querySelectorAll('[data-mgm-step]'));
      var imgs=[].slice.call(root.querySelectorAll('[data-mgm-stage-img]'));
      var bar=root.querySelector('[data-mgm-progress]');
      var label=root.querySelector('[data-mgm-stagename]');
      var n=steps.length||1;
      function setActive(i){
        steps.forEach(function(s,j){s.classList.toggle('cur',j===i);s.classList.toggle('seen',j<i)});
        imgs.forEach(function(im,j){im.classList.remove('on','dim');if(j<i){im.classList.add('dim');im.style.setProperty('--sx',((j-i)*12)+'%');im.style.setProperty('--sy','30%')}else if(j===i){im.classList.add('on')}});
        if(bar)bar.style.height=(((i+1)/n)*100)+'%';
        if(label&&steps[i]){label.textContent=(steps[i].getAttribute('data-mgm-label')||'')}
      }
      setActive(0);
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){
          es.forEach(function(e){if(e.isIntersecting){var i=steps.indexOf(e.target);if(i>-1)setActive(i)}});
        },{rootMargin:'-40% 0px -40% 0px',threshold:0});
        steps.forEach(function(s){io.observe(s)});
      }
      steps.forEach(function(s){
        var head=s.querySelector('.mgm-cue-head');
        if(head)head.addEventListener('click',function(){
          if(window.innerWidth>820)return;
          var open=s.classList.contains('open');
          steps.forEach(function(o){o.classList.remove('open')});
          if(!open){s.classList.add('open');var i=steps.indexOf(s);if(i>-1)setActive(i)}
        });
      });
      if(window.innerWidth<=820&&steps[0])steps[0].classList.add('open');
    });
  }

  function initAll(scope){initReveals(scope||document);initCues(scope||document)}
  ready(function(){initAll(document)});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();
